import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { DeleteWorkRequestParams } from '@/features/work/api/delete-work-request/request';
import { deleteWorkRequest } from '@/features/work/api/delete-work-request/request';

export const useDeleteWorkRequestMutation = (
  settings?: MutationSettings<DeleteWorkRequestParams, typeof deleteWorkRequest>
) =>
  useMutation({
    mutationKey: ['DeleteWorkRequest'],
    mutationFn: ({ params, config }) =>
      deleteWorkRequest({
        params,
        config
      }),
    ...settings?.options
  });
